import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';

/**
 * FooterComponent is a standalone component that represents the footer of the application.
 * The footer is hidden on login and signup pages.
 */
@Component({
  selector: 'app-footer',
  imports: [
    ButtonModule,
    ToolbarModule,
    RouterModule
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  links: MenuItem[] = [
    {label: $localize`Imprint`, url: 'https://www.brandshelter.com/legal-notice/'},
    {label: $localize`Disclaimer`, url: 'https://www.brandshelter.com/disclaimer/'},
    {label: $localize`Privacy Policy`, url: 'https://www.brandshelter.com/privacy-policy/'},
    {label: $localize`Data Processing Agreement`, url: 'http://localhost:3000/papers/Data%20Processing%20Agreement%20Key-Systems_May%202018.pdf'},
    {label: $localize`Terms and Conditions`, url: 'https://www.brandshelter.com/terms-conditions/'},
    {label: $localize`Registration Agreement`, url: 'https://www.brandshelter.com/registration-agreement/'},
    {label: $localize`Registrant Rights and Responsibilities`, url: 'https://www.icann.org/resources/pages/responsibilities-2014-03-14-en'},
  ];

  endLinks: MenuItem[] = [
    {label: $localize`© Key-Systems GmbH`, url: 'https://www.key-systems.net/en/homepage'},
  ]

  constructor(private router: Router) {}

  shouldShowFooter(): boolean {
    const currentPath = this.router.url;
    return !currentPath.includes('/login') && !currentPath.includes('/signup');
  }
}
